<template>
  <b-alert
      v-if="hasAnyError"
      class="mt-3"
      variant="danger"
      show=""
      dismissible
  >
    <li v-for="errorKey in errorBag.keys()" :key="errorKey">
      {{ errorBag.get(errorKey) }}
    </li>
  </b-alert>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "errorAlert",
  methods: {
  },
  computed: {
    ...mapState('errorBag', {
      errorBag: (state) => state.errorBag,
    }),
    hasAnyError() {
      return this.$store.getters['errorBag/any']
    }
  },
}
</script>
